document.addEventListener('DOMContentLoaded', function () {
  function initStickyFilters() {
    const tab = document.querySelector('.cc-filters');
    const results = document.querySelector('.cc-filters-results .grid-layout');
    if (!tab || !results) return;

    const minWidth = 768;
    const wrapper = tab.closest('.cc-filters-main') || tab.parentElement;

    if (getComputedStyle(wrapper).position === 'static') {
      wrapper.style.position = 'relative';
    }

    let savedLeft = 0;
    let savedWidth = 0;

    function measureFilters() {
      const prevPosition = tab.style.position;
      tab.style.position = '';
      tab.style.left = '';
      tab.style.width = '';
      const rect = tab.getBoundingClientRect();
      savedLeft = rect.left + window.scrollX;
      savedWidth = rect.width;
      tab.style.position = prevPosition;
    }

    const topOffset = 110; // gap from top of viewport

    function handleSticky() {
      if (window.innerWidth < minWidth) {
        tab.removeAttribute('style');
        tab.classList.remove('is-fixed');
        return;
      }

      const scrollY = window.scrollY;
      const wrapperRect = wrapper.getBoundingClientRect();
      const resultsRect = results.getBoundingClientRect();
      const tabHeight = tab.offsetHeight;

      const resultsTopAbsolute = scrollY + resultsRect.top;
      const resultsBottomAbsolute = scrollY + resultsRect.bottom;

      const stickStart = resultsTopAbsolute - topOffset;
      const stickEnd = resultsBottomAbsolute - tabHeight - topOffset;

      // Skip sticky if results are too short
      if (resultsRect.height <= tabHeight) {
        tab.removeAttribute('style');
        tab.classList.remove('is-fixed');
        return;
      }

      if (scrollY >= stickStart && scrollY <= stickEnd) {
        tab.style.position = 'fixed';
        tab.style.top = topOffset + 'px';
        tab.style.left = savedLeft + 'px';
        tab.style.width = savedWidth + 'px';
        tab.classList.add('is-fixed');
      } else if (scrollY > stickEnd) {
        tab.style.position = 'absolute';
        tab.style.top = (results.offsetHeight - tabHeight) + 'px';
        tab.style.left = (savedLeft - wrapperRect.left) + 'px';
        tab.style.width = savedWidth + 'px';
        tab.classList.remove('is-fixed');
      } else {
        tab.removeAttribute('style');
        tab.classList.remove('is-fixed');
      }
    }

    window.removeEventListener('resize', handleSticky);
    window.removeEventListener('scroll', handleSticky);

    window.addEventListener('resize', () => {
      measureFilters();
      handleSticky();
    });
    window.addEventListener('scroll', handleSticky, { passive: true });

    measureFilters();
    handleSticky();
  }

  // Initial run
  initStickyFilters();

  // Re-run on Shopify filter reload
  document.addEventListener('shopify:section:load', initStickyFilters);
  document.addEventListener('shopify:section:render', initStickyFilters);
  document.addEventListener('cc:filters:updated', initStickyFilters);

  // MutationObserver fallback
  const resultsContainer = document.querySelector('.cc-filters-results');
  if (resultsContainer) {
    const observer = new MutationObserver(() => {
      setTimeout(initStickyFilters, 100);
    });
    observer.observe(resultsContainer, { childList: true, subtree: true });
  }
});